import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Flame, ArrowRight } from "lucide-react";

/**
 * Homepage double-bounty banner. Only renders when the referral boost is active.
 * DB-driven (via /api/referrals/boost) so it flips on/off without a redeploy.
 */
export default function BoostBanner() {
  const [boost, setBoost] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      api
        .get("/referrals/boost")
        .then((r) => alive && setBoost(r.data))
        .catch(() => {});
    load();
    const t = setInterval(load, 60000); // refresh every minute
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  if (!boost?.active) return null;

  const prize = boost.prize_eur;
  const base = boost.base_prize_eur || 10;
  const hoursLeft = boost.hours_left;

  return (
    <Link
      to="/referrals"
      data-testid="homepage-boost-banner"
      className="group block mb-6 border-2 border-amber-500 bg-amber-500/10 hover:bg-amber-500/20 transition-colors px-4 py-3 sm:px-5 sm:py-4"
    >
      <div className="flex items-center gap-3">
        <Flame className="w-6 h-6 text-amber-500 shrink-0 animate-pulse" />
        <div className="min-w-0 flex-1">
          <div className="flex items-baseline gap-2 flex-wrap">
            <span className="display text-lg sm:text-xl text-amber-500 leading-none">
              DOUBLE BOUNTY LIVE
            </span>
            <span className="text-neutral-200 font-bold">
              €{prize} per signup
            </span>
            <span className="text-[10px] uppercase tracking-widest text-neutral-400 line-through">
              was €{base}
            </span>
          </div>
          <div className="text-[11px] uppercase tracking-widest text-amber-200/90 mt-1">
            {hoursLeft > 0 ? `${hoursLeft}h left` : "Ends soon"} · Refer a mate,
            cash out via credits
          </div>
        </div>
        <ArrowRight className="w-4 h-4 text-amber-500 shrink-0 group-hover:translate-x-1 transition-transform" />
      </div>
    </Link>
  );
}
